<template>
  <div class="pay-wrapper">

    <div class="pay-content" v-loading="payLoadingVisible">

      <!-- 标题和关闭按钮 -->
      <div class="pay-header-box">
        <div class="pay-title">
          <span>保存无水印证件照</span>
          <i class="iconfont iconx" @click="togglePayDialogVisibleFunc(false)"></i>
        </div>
        <div class="pay-subtitle">照片将更新到简历，同时也会自动下载至你的电脑本地</div>
      </div>

      <!-- 非会员 -->
      <template v-if="userMemberStatus === 'timeout' || userMemberStatus === 'null'">
        <!-- 类型 -->
        <div class="pay-type-box">

          <!-- 次数 -->
          <!-- <div class="pay-type number" :class="{'active': tabType === 'number'}" @click="toggleTabFunc('number')">
            <p>¥ <span>9.9</span> /次</p>
            <p>单独购买证件照</p>
          </div> -->

          <!-- 会员 -->
          <div class="pay-type member" :class="{'active': tabType === 'member'}" @click="notMemberToggleTabFunc('member')">
            <span class="sign" v-if="!userPhotoCount">限时</span>
            <template v-if="userPhotoCount">
              <p>免费保存</p>
              <p>当前可免费保存 {{ userPhotoCount }} 次</p>
            </template>
            <template v-else>
              <p>开会员 免费下</p>
              <p>另有 6 大尊享特权</p>
            </template>
          </div>

        </div>

        <!-- 支付二维码 -->
        <div class="qrcode-box" v-show="tabType === 'number'">

          <div class="qrcode-box-left">
            <qrcode-vue class="qrcode-box-left-qrcode" :value="targetLink" :size='126'/>
            <div class="qrcode-box-left-info">
              <span class="price">￥9.9</span>
              <div class="icon">
                <img src="https://files.wondercv.com/web/member/wechat.png" alt="">
                <img src="https://files.wondercv.com/web/member/alipay.png" alt="">
              </div>
              <p class="desc">使用支付宝/微信，扫码支付</p>
            </div>
          </div>

          <div class="qrcode-box-right">
            <div class="btn" @click="debounce(() => { checkOrderStatusFunc('buttonClick') }, 300)">支付成功</div>
            <p class="desc" @click="goUdeskFunc()">已付款，显示支付失败？</p>
          </div>

        </div>

        <!-- 保存 -->
        <div class="save-box" v-show="tabType === 'member'">

          <div class="save-box-left">
            <img class="save-box-left-icon" src="https://files.wondercv.com/PC/cvs/photo/icon.png" alt="">
            <div class="save-box-left-info">
              <p>免费保存证件照<span>（剩余 {{ userPhotoCount }} 次）</span></p>
              <p>普通会员可免费保存 1 次，终身会员可免费保存 5 次</p>
            </div>
          </div>

          <div class="save-box-right"
            v-if="(userMemberStatus === 'timeout' || userMemberStatus === 'null') && !userPhotoCount"
            @click="notMemberToggleTabFunc('member')"
          >开通会员</div>
          <div class="save-box-right" v-else @click="debounce(() => { savePhotoFunc() }, 300)">保存照片</div>

        </div>
      </template>

      <!-- 普通会员 -->
      <template v-else-if="userMemberStatus === 'super'">
        <!-- 类型 -->
        <div class="pay-type-box">

          <!-- 次数 -->
          <div class="pay-type number" :class="{'active': tabType === 'number'}" @click="toggleTabFunc('number')">
            <p>¥ <span>5.9</span> /次</p>
            <p>单独购买证件照</p>
          </div>

          <!-- 会员 -->
          <div class="pay-type member" :class="{'active': tabType === 'member'}" @click="toggleTabFunc('member')">
            <p>会员免费保存</p>
            <p>会员可免费保存证件照</p>
          </div>

        </div>

        <!-- 提示文案 -->
        <div class="reminder-box" v-if="(tabType === 'member') && !userPhotoCount">
          <i class="iconfont iconcuowu"></i>
          <span>您的免费保存证件照权限已使用，升级终身会员可额外获得 5 次免费保存权利，及 3 大专属求职特权</span>
        </div>

        <!-- 支付二维码 -->
        <div class="qrcode-box" v-show="tabType === 'number'">

          <div class="qrcode-box-left">
            <qrcode-vue class="qrcode-box-left-qrcode" :value="targetLink" :size='126'/>
            <div class="qrcode-box-left-info">
              <span class="price">￥5.9</span>
              <div class="icon">
                <img src="https://files.wondercv.com/web/member/wechat.png" alt="">
                <img src="https://files.wondercv.com/web/member/alipay.png" alt="">
              </div>
              <p class="desc">使用支付宝/微信，扫码支付</p>
            </div>
          </div>

          <div class="qrcode-box-right">
            <div class="btn" @click="debounce(() => { checkOrderStatusFunc('buttonClick') }, 300)">支付成功</div>
            <p class="desc" @click="goUdeskFunc()">已付款，显示支付失败？</p>
          </div>

        </div>

        <!-- 保存 -->
        <div class="save-box" v-show="tabType === 'member'">

          <div class="save-box-left">
            <img class="save-box-left-icon" src="https://files.wondercv.com/PC/cvs/photo/icon.png" alt="">
            <div class="save-box-left-info">
              <p>免费保存证件照<span :class="!userPhotoCount && 'active'">（剩余 {{ userPhotoCount }} 次）</span></p>
              <p>普通会员可免费保存 1 次，终身会员可免费保存 5 次</p>
            </div>
          </div>

          <div class="save-box-right" v-if="userPhotoCount" @click="debounce(() => { savePhotoFunc() }, 300)">保存照片</div>
          <div class="save-box-right" v-else @click="toBuyMemberFunc()">升级会员</div>

        </div>
      </template>

      <!-- 终身会员 -->
      <template v-else-if="userMemberStatus === 'life'">
        <!-- 类型 -->
        <div class="pay-type-box">

          <!-- 次数 -->
          <div class="pay-type number" :class="{'active': tabType === 'number'}" @click="toggleTabFunc('number')">
            <p>¥ <span>5.9</span> /次</p>
            <p>单独购买证件照</p>
          </div>

          <!-- 会员 -->
          <div class="pay-type member" :class="{'active': tabType === 'member'}" @click="toggleTabFunc('member')">
            <p>会员免费保存</p>
            <p>会员可免费保存证件照</p>
          </div>

        </div>

        <!-- 提示文案 -->
        <div class="reminder-box" v-if="(tabType === 'member') && !userPhotoCount">
          <i class="iconfont iconcuowu"></i>
          <span>您的免费保存证件照权限已全部用完，如仍需保存证件照，可享受会员专享价格购买，仅需 5.9 元/次</span>
        </div>

        <!-- 支付二维码 -->
        <div class="qrcode-box" v-show="tabType === 'number'">

          <div class="qrcode-box-left">
            <qrcode-vue class="qrcode-box-left-qrcode" :value="targetLink" :size='126'/>
            <div class="qrcode-box-left-info">
              <span class="price">￥5.9</span>
              <div class="icon">
                <img src="https://files.wondercv.com/web/member/wechat.png" alt="">
                <img src="https://files.wondercv.com/web/member/alipay.png" alt="">
              </div>
              <p class="desc">使用支付宝/微信，扫码支付</p>
            </div>
          </div>

          <div class="qrcode-box-right">
            <div class="btn" @click="debounce(() => { checkOrderStatusFunc('buttonClick') }, 300)">支付成功</div>
            <p class="desc" @click="goUdeskFunc()">已付款，显示支付失败？</p>
          </div>

        </div>

        <!-- 保存 -->
        <div class="save-box" v-show="tabType === 'member'">

          <div class="save-box-left">
            <img class="save-box-left-icon" src="https://files.wondercv.com/PC/cvs/photo/icon.png" alt="">
            <div class="save-box-left-info">
              <p>免费保存证件照<span :class="!userPhotoCount && 'active'">（剩余 {{ userPhotoCount }} 次）</span></p>
              <p>普通会员可免费保存 1 次，终身会员可免费保存 5 次</p>
            </div>
          </div>

          <div class="save-box-right" v-if="userPhotoCount" @click="debounce(() => { savePhotoFunc() }, 300)">保存照片</div>

        </div>
      </template>

    </div>

  </div>
</template>

<script>
import api from '@/api'
import QrcodeVue from 'qrcode-vue'
import { uuid } from 'vue-uuid'
import { mapState, mapMutations, mapActions } from 'vuex'
import { routerTo, userMemberCheck } from '@/assets/js/util'
import { componentsMixin } from '@/assets/js/mixins/components'

export default {
  props: {
    // 用户可制作证件照次数
    userPhotoCount: {
      type: Number,
      default: 0
    },
    // loading visible
    payLoadingVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      /**
       * 非会员（包含过期）无次数、非会员（包含过期）有次数
       * 会员无次数、会员有次数
       * 终身会员无次数、终身会员有次数
       * 
       * 非会员无次数、终身会员无次数 默认展示二维码 tabType=number
       * 其他情况都 默认展示 tabType=tabType
       * 
       */
      tabType: 'member', // tab 类型 可能的值： 1. number 购买次数 2. member 会员
      userMemberStatus: 'null', // 用户会员状态 可能的值： 1. timeout 已过期 2. null 非会员 3. super 超级会员 4. life 终身会员
      orderToken: null, // 订单 token
      payType: 'cPhotoBeauty', // 支付类型 c端照片美颜
      host: null,
      timer: null,
      isPending: false, // 是否正在请求接口 检查订单
    }
  },
  mixins: [ componentsMixin ],
  components: {
    QrcodeVue
  },
  async created () {
    this.host = window.location.origin.replace("www", "m")
    // 获取用户会员状态
    this.userMemberStatus = userMemberCheck(this.personInfo.membership_expired_at)
    // this.userMemberStatus = 'timeout'
    // if(this.userMemberStatus === 'null' || this.userMemberStatus === 'timeout'){
    //   this.tabType = 'member'
    // }
    // 初始化模块展示类型
    this.initModuleTypeFunc()
  },
  mounted () {
  },
  destroyed () {
    // 关闭订单监听
    this.closeCheckFunc()
  },
  computed: {
    ...mapState('me', ['personInfo']),

    // 二维码跳转地址
    targetLink () {
      return `${this.host}/pay/type?type=${this.payType}&orderId=${this.orderToken}`
    }
  },
  methods: {
    ...mapMutations('editor', ['setPortraitDialogVisible']),
    ...mapActions('me', ['getUserInfo']),

    // 打开客服
    goUdeskFunc () {
      let udesk_container = document.querySelector('#udesk_btn a');
      if(udesk_container != null){
        udesk_container.click();
      }
    },
    // 控制支付弹窗的出现和隐藏
    togglePayDialogVisibleFunc (val) {
      this.$emit('togglePayDialogVisible', val)
    },
    // 开启监听
    openCheckFunc () {
      this.timer = setInterval(() => {
        // 检查订单状态
        this.checkOrderStatusFunc()
      }, 3000)
    },
    // 关闭监听
    closeCheckFunc () {
      clearInterval(this.timer)
    },
    // 初始化模块展示类型
    initModuleTypeFunc () {

      let status = this.userMemberStatus
      let count = this.userPhotoCount
      if (status === 'timeout' || status === 'null') {
        this.tabType = 'member'
        // this.tabType = (!!count ? 'member' : 'number')
      } else if (status === 'super') {
        this.tabType = (!!count ? 'member' : 'member')
      } else if (status === 'life') {
        this.tabType = (!!count ? 'member' : 'number')
      }

    },
    // 非会员的 tab 切换
    notMemberToggleTabFunc (val) {
      if(this.userPhotoCount) {
        // 有次数 正常切换
        this.toggleTabFunc(val)
      } else {
        // 没有次数 跳转到会员页面 并且关闭支付弹窗
        this.toBuyMemberFunc()
      }
    },
    // 跳转到 会员购买页面
    toBuyMemberFunc () {
      routerTo('/account/users/buy_member', '_blank')
      // 触发去会员页面按钮，需要重新获取用户会员信息 应该用户回来时可能已经开通会员了
      this.getUserInfo()
      this.togglePayDialogVisibleFunc(false)
    },
    // 切换 tab
    toggleTabFunc (val) {
      this.tabType = val
    },
    // 保存照片
    savePhotoFunc () {
      // 获取无水印证件照 然后触发浏览器下载 并 保存到简历
      this.$emit('getNoWatermarkedPhoto')
    },
    // 检查支付成功的回调
    paidFunc () {
      this.savePhotoFunc()
      this.$message.success('支付成功')
    },
    // 检查订单状态
    async checkOrderStatusFunc (type) {
      if (this.isPending) return false
      this.isPending = true
      try {
        let params = this.orderToken
        let res = await api.portrait.checkOrderStatus(params)
        if (res.code === 1000) {
          if (res.data.status === 'paid') {
            this.closeCheckFunc()
            // 检查支付成功的回调
            this.paidFunc()
          } else {
            (type === 'buttonClick') && this.$message.error("订单支付失败，请继续支付")
          }
        } else {
          this.$message.error(res.message)
        }
        this.isPending = false
      } catch (error) {
        console.log(error)
        this.isPending = false
      }
    },
    // 创建订单
    async createPhotoBeautyOrderFunc () {
      try {
        let res = await api.portrait.createPhotoBeautyOrder()
        if (res.code === 1000) {
          this.orderToken = res.data.token
          // 创建完订单后 开启订单状态监听
          this.openCheckFunc()
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  watch: {
    // 监听 当第一次切换到 tabType=number 时，创建订单
    tabType (newVal, oldVal) {
      if (newVal === 'number' && !this.orderToken) {
        this.createPhotoBeautyOrderFunc()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";
</style>
